import GameActionType from './gameActionType';

export const changeGameLoadingState = (state) => ({
  type: GameActionType.CHANGE_GAME_LOADING_STATE,
  payload: { state },
});

export const getFreeGameProviders = (brandId, params) => ({
  type: GameActionType.GET_FREE_GAME_PROVIDERS,
  payload: { brandId, params },
});

export const saveFreeGameProviders = (data) => ({
  type: GameActionType.SAVE_FREE_GAME_PROVIDERS,
  payload: { data },
});

export const resetFreeGameProviders = () => ({
  type: GameActionType.RESET_FREE_GAME_PROVIDERS,
});

export const getFreeGamesV2Providers = (brandId, params) => ({
  type: GameActionType.GET_FREE_GAMES_V2_PROVIDERS,
  payload: { brandId, params },
});

export const saveFreeGamesV2Providers = (data) => ({
  type: GameActionType.SAVE_FREE_GAMES_V2_PROVIDERS,
  payload: { data },
});

export const resetFreeGamesV2Providers = () => ({
  type: GameActionType.RESET_FREE_GAMES_V2_PROVIDERS,
});

export const getFreeGames = (brandId, params) => ({
  type: GameActionType.GET_FREE_GAMES,
  payload: { brandId, params },
});

export const saveFreeGames = (data) => ({
  type: GameActionType.SAVE_FREE_GAMES,
  payload: { data },
});

export const resetFreeGames = () => ({
  type: GameActionType.RESET_FREE_GAMES,
});

export const getFreeGamesV2 = (brandId, params) => ({
  type: GameActionType.GET_FREE_GAMES_V2,
  payload: { brandId, params },
});

export const saveFreeGamesV2 = (data) => ({
  type: GameActionType.SAVE_FREE_GAMES_V2,
  payload: { data },
});

export const resetFreeGamesV2 = () => ({
  type: GameActionType.RESET_FREE_GAMES_V2,
});

export const getFreeGameAmountRestrictions = (brandId, params) => ({
  type: GameActionType.GET_FREE_GAME_AMOUNT_RESTRICTIONS,
  payload: { brandId, params },
});

export const saveFreeGameAmountRestrictions = (data) => ({
  type: GameActionType.SAVE_FREE_GAME_AMOUNT_RESTRICTIONS,
  payload: { data },
});

export const resetFreeGameAmountRestrictions = () => ({
  type: GameActionType.RESET_FREE_GAME_AMOUNT_RESTRICTIONS,
});

export const changeFreeGameLoadingState = (state) => ({
  type: GameActionType.CHANGE_FREE_GAME_LOADING_STATE,
  payload: { state },
});

export const changeFreeGameAmountLoadingState = (state) => ({
  type: GameActionType.CHANGE_FREE_GAME_AMOUNT_LOADING_STATE,
  payload: { state },
});

export const getFreeGamesV2AmountRestrictions = (brandId, params) => ({
  type: GameActionType.GET_FREE_GAMES_V2_AMOUNT_RESTRICTIONS,
  payload: { brandId, params },
});

export const saveFreeGamesV2AmountRestrictions = (data) => ({
  type: GameActionType.SAVE_FREE_GAMES_V2_AMOUNT_RESTRICTIONS,
  payload: { data },
});

export const resetFreeGamesV2AmountRestrictions = () => ({
  type: GameActionType.RESET_FREE_GAMES_V2_AMOUNT_RESTRICTIONS,
});
